<!--

   V 0.5.1 - 2025-09-30
     - Changed colour of pause icon and made it bigger

   V 0.5.0 - 2025-09-22
     - Added Autoplay function

   V 0.4.0 - 2025-09-01
     - Added button to allow only one trip at a time to be viewed.

   V 0.3.0 - 2025-03-18
     - Added event button, and modification to
       total day

   V 0.2.0 - 2025-02-24
     - Added Trip Slider

   V 0.1.0 - 2025-02-19
     - <router-view> in n for handling paths

 -->
<template>
  <v-container>
    <div id="map" :style="mapStyle"></div>

    <v-row>
      <v-col cols="auto">
        <v-progress-circular v-show="isLoading"
                             class="progress-overlay"
                             indeterminate
                             size="120"
                             width="15"
                             color="primary" />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="auto">
        <v-btn style="
            z-index: 1 !important;
            top: 15px !important;
            left: 10px;
            height: 32px !important;
            width: 30px !important;
            position: absolute;
            background-color: #ffffff;
            border-radius: 4px;
            border : 1px solid #202730;
            padding: 3px;
            color: #fff;
            min-width: 35px;
          "
               id="buttonReplay"
               dark
               small
               color="red"
               @click="replay">
          <v-icon dark> mdi-refresh </v-icon>
        </v-btn>

        <!-- New 3-dot menu for interval selection -->
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn style="
                    background-color: #2196f3;
                    z-index: 1 !important;
                    top: 16px; left: 48px; height: 32px !important;
                    position: absolute; border-radius: 2px;
                    padding: 3px; color: #fff; "
                   icon
                   v-bind="attrs"
                   v-on="on">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item v-for="option in intervalOptions"
                         :key="option.value"
                         @click="setTimerInterval(option.value)">
              <v-list-item-title>{{ option.text }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-switch style="
            z-index: 1 !important;
            top: 0px;
            left: 48px;
            height: 32px !important;
            position: absolute;
            background-color: #ffffff;
            border-radius: 4px;
            border: 1px solid #202730;
            padding: 3px;
            color: #fff;
          "
                  v-if="showStep"
                  dense
                  small
                  @change="onZoomToggleChange"
                  v-model="zoomButton"
                  :label="switchZoomLabel">
        </v-switch>

        <v-switch style="
            z-index: 1 !important;
            top: 0px;
            left: 145px;
            height: 32px !important;
            position: absolute;
            background-color: #ffffff;
            border-radius: 4px;
            border: 1px solid #202730;
            padding: 3px;
            color: #fff;
          "
                  v-if="showStep"
                  dense
                  small
                  @change="onEventsToggleChange"
                  v-model="eventsButton"
                  :label="switchEventsLabel">
        </v-switch>
        <v-switch style="
            z-index: 1 !important;
            top: 0px;
            left: 247px;
            height: 32px !important;
            position: absolute;
            background-color: #ffffff;
            border-radius: 4px;
            border: 1px solid #202730;
            padding: 3px;
            color: #fff;
          "
                  v-if="showStep"
                  dense
                  small
                  @change="onAllTripsToggleChange"
                  v-model="allTripsButton"
                  :label="switchAllTripsLabel">
        </v-switch>

        <!-- New Auto button (toggle play/pause) -->
        <v-btn style="
      z-index: 1 !important;
      top: 16px;
      left: 320px;
      height: 32px !important;
      position: absolute;
      background-color: #ffffff;
      border-radius: 4px;
      border: 1px solid #202730;
      padding: 3px;
      color: #fff;
      min-width: 33px;
      width: 30px;
    "
               v-if="showStep"
               dense
               small
               @click="toggleAuto"
               :color="intervalId ? 'error' : 'primary'">
          <v-icon left>
            {{ intervalId ? "mdi-pause" : "mdi-play" }}
          </v-icon>
        </v-btn>

      </v-col>
    </v-row>

    <v-row v-if="showStep">
      <!-- Navigation Buttons -->
      <v-col class="d-flex flex-column justify-start">
        <v-btn style="
            position: absolute;
            left: 10px;
            top: 60px;
            z-index: 1 !important;
          "
               small
               @click="prevStop"
               :disabled="selectedIndex === 0"
               class="no-margin">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-btn style="
            position: absolute;
            left: 60px;
            top: 60px;
            z-index: 1 !important;
          "
               small
               @click="nextStop"
               :disabled="selectedIndex === stops.length - 1"
               class="ml-2">
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row no-gutters v-if="showStep">
      <v-col cols="2" class="d-flex align-center justify-center">
        <v-slider style="
            position: absolute;
            left: 20px;
            top: -10px;
            z-index: 1 !important;
          "
                  :thumb-size="24"
                  ticks
                  v-model="selectedIndex"
                  :max="stops.length - 1"
                  min="0"
                  step="1"
                  label=""
                  thumb-label="always"
                  vertical
                  height="400"
                  @input="updatePosition">
          <template v-slot:thumb-label="{ value }">
            {{ sliderTag(value) }}
            <v-icon small color="white" v-if="sliderTag(value) == '' ">
              fa-pause

            </v-icon>
          </template>
        </v-slider>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
/* eslint-disable camelcase */
/* eslint-disable max-len */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-plusplus */
/* eslint-disable func-names */
/* eslint-disable padded-blocks */
/* eslint-disable indent */

  import axios from 'axios'

  class Violation {
    constructor (Dt, Desc, Id, Lat, Lng, Speed) {
      this.Date = new Date(Dt)
      this.Desc = Desc
      this.Id = Id
      this.Lat = Lat
      this.Lng = Lng
      this.Speed = Speed
      console.log(this)
    }
  }

  class Point {
    constructor (tm, lat, lng, spd) {
      this.tm = new Date(tm)
      this.lat = lat
      this.lng = lng
      this.spd = spd
    }
  }

  class Trip {
    constructor (pointsJson, distance, label, violationsJSON) {
      this.points = JSON.parse(pointsJson).map(
        (p) => new Point(p.tm, p.lat, p.lng, p.spd)
      )
      this.distance = distance / 1000
      this.label = label
      // debugger;
      this.violations = JSON.parse(violationsJSON).map(
        (p) => new Violation(p.Date, p.Desc, p.Id, p.Lat, p.Lng, p.Speed)
      )
    }
  }

  /**
   *  V 0.2.0 - 2025-11-11
   *    - Modified'fontFamily' because I was gertting bad font displays
   *      on mobile devices.
   *
   *  V 0.1.0 - ] s
   */
  class SpeedGmapControl {
    constructor (controlDiv, map) {
      const controlUI = document.createElement('div')
      controlUI.style.backgroundColor = '#fff'
      controlUI.style.border = '2px solid #fff'
      controlUI.style.borderRadius = '1px'
      controlUI.style.boxShadow = '0 2px 6px rgba(0,0,0,.3)'
      controlUI.style.cursor = 'pointer'
      controlUI.style.marginBottom = '12px'
      controlUI.style.textAlign = 'center'
      controlUI.title = 'Click to recenter the map'
      controlDiv.appendChild(controlUI)

      const controlText = document.createElement('div')
      controlText.style.color = 'rgb(25,25,25)'
      controlText.style.fontFamily = 'Roboto,Arial,sans-serif' //
      // controlText.style.fontFamily = '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif'
      controlText.style.fontSize = '14px'
      controlText.style.lineHeight = '22px' // change this to reduce box size
      controlText.style.paddingLeft = '5px'
      controlText.style.paddingRight = '5px'
      controlText.innerHTML =
        'Speed: <span id="idSpeed"></span> Trip - Time - Distance <span id="idTime"></span>'
      controlUI.appendChild(controlText)
      this.GmapControlOutput = controlText
    }
  }

  export default {
    data () {
      return {

        timerInterval: this.$store.state.navPlayTimerInterval, //  3000, // Default: 3 seconds (in milliseconds)
        intervalOptions: [
          { text: '1 second', value: 1000 },
          { text: '3 seconds', value: 3000 },
          { text: '5 seconds', value: 5000 }
        ], // Menu options

        intervalId: null, // New: To store the setInterval ID
        ////////////////////////////////////////////

        allTripsButton: this.$store.state.allTripsButton,
        switchAllTripsLabel: 'All',
        tripPolyline: null,

        //////////////////////////////////////////////
        markers: [],
        icons: [],

        eventsButton: this.$store.state.eventsButton,
        switchEventsLabel: 'Events',

        eventMarkers: [],

        mapStyle: {
          position: 'absolute',
          top: '0px',
          left: '0px',
          width: '100vw',
          /// -----------------------------------------------------------
          /// 2025-03-18
          ///   - changed apple device from 90dvh &  93 dvh to 91dvh and 94dvh
          /// -----------------------------------------------------------
          height: this.isAppleDevice() ? '91dvh' : '94dvh'
        },

        showStep: false,
        isLoading: false,
        /// Added from TripPlotAll
        /// -------------------------------------------------------

        VehicleID: -1,
        dayDate: '',
        previousPage: '',
        UnitID: '',
        VehicleReg: '',
        pageMap: null,

        /// -------------------------------------------------------
        totalTripMarkers: [],
        switchZoomLabel: 'Zoom',
        zoomLabel: false,
        output: null,

        debug: this.$debug,

        selectedIndex: 0, // Default to first stop
        selectedStop: null,

        zoomButton: false,
        breadCrumb: false,

        highlightedMarkers: null,
        highlightedTrip: null,

        advancedMarkers: [],

        tripData: {},

        map: null,
        stops: [],

        journeyPath: [],
        tripPath: [],
        trips: []
      }
    },

    // Place beforeDestroy here, at the same level as data and methods
    beforeDestroy () {
      if (this.intervalId) {
        clearInterval(this.intervalId)
        this.intervalId = null
      }
    },

    mounted () {
      // this.fetchData()
      this.fetchLiveData()
    },

    /**
     *  ++++++++++++++++++++++++++++++++++++++++++++ Methods ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
     */
    methods: {
      fetchLiveData () {
        let url = `${this.$baseUrl}/api/v2/trip-plot?`
        url += `UnitID=${this.$route.params.UnitID}&`
        url += `Day=${this.$route.params.dayDate}`

        this.UnitID = this.$route.params.UnitID
        this.VehicleReg = this.$route.params.VehicleReg

        if (typeof this.$route.params.previousPage !== 'undefined') {
          this.previousPage = this.$route.params.previousPage
        }

        if (typeof this.$route.params.dayDate !== 'undefined') {
          this.dayDate = this.$route.params.dayDate
        }

        if (typeof this.$route.params.VehicleID !== 'undefined') {
          this.VehicleID = this.$route.params.VehicleID
        }

        this.$debug ? console.log(url) : null

        this.isLoading = true

        this.$axios
          .get(url)
          .then((response) => {
            this.$debug ? console.log(response.data) : null
            this.tripData = response.data
            this.error = null
            this.isLoading = false
            this.processData()

            this.initMap()

            // this.replay()
          })
          .catch((e) => {
            this.isLoading = false
            console.log(e)
          })
      },

      /**
       *  V 0.1.0 - 2025-02-19
       *
       *
       */
      fetchData () {
        axios
          .get('/api/trip4.json') // Adjust the path based on your setup
          .then((response) => {
            this.tripData = response.data
            this.error = null

            this.processData()

            this.initMap()
          })
          .catch((err) => {
            this.error = 'Error fetching data: ' + err.message
            this.data = null
          })
      },

      /**
       *
       *
       */
      updatePosition (value) {
        this.goToPoint(this.selectedIndex)
        const lbl = this.stops[this.selectedIndex].label
        this.updateSpeed(lbl)
      },

      /**
       * - - - - - - - - - - - - - - - - - - - - - - - - - -  - - - - - - - - - - - - - - - - - - - - - - - - - -
       *
       *
       *
       * - - - - - - - - - - - - - - - - - - - - - - - - - -  - - - - - - - - - - - - - - - - - - - - - - - - - -
       * */
      advancedMarkerFontAwesome (lat, lng, value, alarmId) {
        const markerElement = document.createElement('div')

        markerElement.innerHTML = this.getEventMarkerContent(alarmId)

        const el = this.getEventMarkerContent(alarmId, true)

        var advancedMarker = new google.maps.marker.AdvancedMarkerElement({
          map: this.map,
          position: { lat: lat, lng: lng },
          zIndex: 10, // 50 - order,
          content: markerElement
        })

        const infoWindow = new google.maps.InfoWindow({
          content: `<strong>${el.text}</strong>`
        })

        markerElement.addEventListener('click', () => {
          infoWindow.open(map, advancedMarker)
        })

        return advancedMarker
      },

      /**
       *   V 0.1.0 - 2025-03-10
       *
       */
      advancedMarkerTag (lat, lng, value, order, tag = 'trip-tag') {
        try {
          var priceTag = document.createElement('div')

          priceTag.className = tag
          priceTag.textContent = `${value}`

          var marker = new google.maps.marker.AdvancedMarkerElement({
            map: this.map,
            position: { lat: lat, lng: lng },
            zIndex: 50 - order,
            content: priceTag
          })

          marker.element.style.opacity = '1' // 50% transparent
          marker.order = order

          return marker
        } catch (e) {
          console.log(e)
        }
      },

      /**
       *  V 0.4.0 - 2025-03-03
       *      -
       *
       *  V 0.3.0 - 2025-02-11
       *      - Added opacity
       *
       *  V 0.2.0 - 2024-07-09
       *      - return the marker
       *
       *  V 0.1.0 - 2024-06-05
       *     - Called from the master form to update things on the form, with the
       *       sliders value.
       *
       */
      advancedMarkerCreate (lat, lng, value, order, tag = 'trip-tag') {
        var priceTag = document.createElement('div')

        priceTag.className = tag
        priceTag.textContent = `${value}`

        var marker = new google.maps.marker.AdvancedMarkerElement({
          map: this.map,
          position: { lat: lat, lng: lng },
          zIndex: 50 - order,
          content: priceTag
        })

        // Set the opacity (0 = fully transparent, 1 = fully opaque)
        marker.element.style.opacity = '0.75' // 50% transparent

        marker.order = order
        return marker
      },

      /**
       * V 0.2.0  - 2025-09-30
       *    - Changed stop to darkgreen to match wait tag
       *
       * V 0.1.0  - 2025-03-10
       *    -  If this is a stop make it blue if it is a trip make it yellow,
       *
       */
      updateSpeed (display) {
        if (display.toLowerCase().includes('wait'.toLowerCase())) {
          this.output.style.backgroundColor = 'darkgreen' // "#4285f4";
          this.output.style.color = '#fff'

        } else {
          this.output.style.backgroundColor = '#fff400e8'
          this.output.style.color = '#000000' // white

        }

        // ||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||

        this.output.innerHTML = '&nbsp;&nbsp;' + display + '&nbsp;&nbsp;'
      },

      isAppleDevice () {
        const userAgent = window.navigator.userAgent
        const platform = window.navigator.platform

        const iosPlatforms = ['iPhone', 'iPad', 'iPod']
        const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K']

        var isApple = false
        var os = ''

        if (iosPlatforms.indexOf(platform) !== -1) {
          isApple = true
          os = 'iOS'
        } else if (macosPlatforms.indexOf(platform) !== -1) {
          os = 'macOS'
          isApple = true
        } else {
          os = 'Unknown OS'
          isApple = false
        }

        this.$debug ? console.log(`isAppleDevice() ${isApple} = ${os} `) : null

        return isApple
      },

      /**
       *  V 0.3.0 - 2025-11-12
       *    - Converted to using icons for pause and not character icons: '⏸' or '🛑'
       *
       *  V 0.2.0 - 2025-03-18
       *    - Added +1 to the tripNum so that slider displays
       *
       *  V 0.1.0 - 2025-02-24
       *    -
       * @param index
       *
       */

      sliderTag (index) {
        this.debug ? console.log(`sliderTag() ${index}`) : null
        if (index >= 0) {
          const stop = this.stops[index]

          if (stop && stop.position) {
            if (stop.trip) {
              if (index < this.stops.length) {
                return (this.stops[index].tripNum + 1).toString()
              } else {
                return 'end'
              }
            } else {
              return ''
              // return '⏸' // ;`'🛑'
            }
          }
          return 0
        }
      },

      replay () {
        this.$debug ? console.log('Replay()') : null
        this.showStep = !this.showStep

        if (this.showStep) {
          // we are now looping between things
          if (this.totalTripMarkers.length > 0) {
            this.totalTripMarkers.forEach((marker, index) => {
              marker.setMap(null)
            })
            this.totalTripMarkers = []

            this.selectedIndex = 0
            this.goToPoint(this.selectedIndex)

            const lbl = this.stops[this.selectedIndex].label
            this.updateSpeed(lbl)
          }
        } else {
          if (this.highlightedMarkers) {
            this.highlightedMarkers.forEach((marker, index) => {
              marker.setMap(null)
            })
          }
          if (this.highlightedTrip) {
            this.highlightedTrip.setMap(null)
          }

          this.plotFullTripMarkers()

          this.zoomToJourney()
        }
      },

      // New: Method to handle interval selection
      setTimerInterval (value) {
        const wasRunning = !!this.intervalId // Check if timer was running
        if (this.intervalId) {
          // Stop the current timer if running
          clearInterval(this.intervalId)
          this.intervalId = null
        }
        this.timerInterval = value // Update interval

        // setTimerInterval
        this.$store.commit('setNavPlayTimerInterval', this.timerInterval)

        if (wasRunning) {
          // Restart the timer with the new interval
          this.intervalId = setInterval(() => {
            this.nextStop()
            if (this.selectedIndex >= this.stops.length - 1) {
              clearInterval(this.intervalId)
              this.intervalId = null
            }
          }, this.timerInterval)
        }
      },

      // New: Start the auto-iteration (and stop if already running, for toggle behavior)
      toggleAuto () {
        if (this.intervalId) {
          // Stop the timer if running
          clearInterval(this.intervalId)
          this.intervalId = null
        } else {
          // Start the timer with the current timerInterval
          this.intervalId = setInterval(() => {
            this.nextStop()
            if (this.selectedIndex >= this.stops.length - 1) {
              clearInterval(this.intervalId)
              this.intervalId = null
            }
          }, this.timerInterval) // Use dynamic interval
        }
      },

      // Optional: If you want a separate stop method (e.g., for a dedicated stop button)
      stopAuto () {
        if (this.intervalId) {
          clearInterval(this.intervalId)
          this.intervalId = null
        }
      },

      nextStop () {
        if (this.selectedIndex < this.stops.length - 1) {
          this.selectedIndex++
          this.goToPoint(this.selectedIndex)

          const lbl = this.stops[this.selectedIndex].label
          this.updateSpeed(lbl)
        }
      },

      prevStop () {
        if (this.selectedIndex > 0) {
          this.selectedIndex--
          this.goToPoint(this.selectedIndex)

          const lbl = this.stops[this.selectedIndex].label
          this.$debug ? console.log(lbl) : null
          this.updateSpeed(lbl)
        }
      },

      onEventsToggleChange () {
        const viewEvents = this.eventsButton

        this.$debug ? console.log('onEventsToggleChange()') : null
        this.$debug ? console.log(this.switchZoomLabel) : null

        this.$store.commit('setEventsButton', this.eventsButton)

        this.switchEventsLabel =
          this.switchEventsLabel === 'Events' ? '' : 'Events'

        if (!viewEvents) {
          this.eventMarkers.forEach((marker, index) => {
            marker.setMap(null)
          })
        } else {
          this.eventMarkers.forEach((marker, index) => {
            marker.setMap(this.map)
          })
        }
      },

      //-------------------------------------------------------------------------------------------------
      //  V 0.1.0 - 2025-09-01
      //     - only display the highlighted trip. Perhaps change the colour of the highlight my ideas is
      //       that I will set the map of the full trip to null
      //-------------------------------------------------------------------------------------------------
      onAllTripsToggleChange () {
        this.$debug ? console.log('onAllTripsToggleChange()') : null
        this.$store.commit('setAllTripsButton', this.allTripsButton)

        if (this.allTripsButton) {
          this.tripPolyline.setMap(this.map)
        } else {
          this.tripPolyline.setMap(null)
        }
      },

      onZoomToggleChange () {
        const zoom = this.zoomButton
        this.$debug ? console.log('onZoomToggleChange()') : null
        this.$debug ? console.log(this.switchZoomLabel) : null

        this.switchZoomLabel = this.switchZoomLabel === 'Zoom' ? '' : 'Zoom'

        if (!zoom) {
          // zoom out to entire trip
          this.zoomToJourney()
        } else {
          // zoom to current trip
          this.goToPoint(this.selectedIndex)
        }
      },

      onToggleChange () {
        const visible = this.breadCrumb
        this.cycleThroughAll(visible)
      },

      // -------------------------------------------------------------------------------------------------
      //   V 0.1.0 - 2025-11-12
      //      -  Converted to using <v-icon> for pause and not character icons: '⏸' or '🛑'
      // -------------------------------------------------------------------------------------------------
      goToPoint (index) {
        this.$debug ? console.log('goToPoint()') : null
        this.$debug ? console.log(index) : null

        const stop = this.stops[index]

        if (stop && stop.position) {
          this.$debug ? console.log(stop.trip) : null

          const points = stop.trip

          if (this.highlightedTrip) {
            this.highlightedTrip.setMap(null)
          }

          if (this.highlightedMarkers) {
            this.highlightedMarkers.forEach((marker, index) => {
              marker.setMap(null)
            })
          }

          if (points) {
            //
            // we need to remove if there is a polyline
            // currently highlug
            //
            this.$debug ? console.log(`Highlight Trip ${stop.index}`) : null

            var tripPolyline

            if (!this.allTripsButton) {
              tripPolyline = new google.maps.Polyline({
                path: points,
                geodesic: true,
                strokeColor: '#FF0000',
                strokeOpacity: 0.8, // 50% transparency
                strokeWeight: 4
              })
            } else {
              tripPolyline = new google.maps.Polyline({
                path: points,
                geodesic: true,
                strokeColor: '#FFFF00',
                strokeOpacity: 0.8, // 50% transparency
                strokeWeight: 16
              })
            }

            tripPolyline.setMap(this.map)

            this.highlightedTrip = tripPolyline

            this.highlightedMarkers = []

            // let display = '⏵'
            let display = ''

            let lat = points[0].lat
            let lng = points[0].lng
            //let adv = this.advancedMarkerTag(lat, lng, display, 0)

            // -----------------------------------------------------------------------------------
            // -----------------------------------------------------------------------------------

            const markerContent1 = document.createElement('div')
            markerContent1.className = 'trip-tag'
            markerContent1.innerHTML = `<i class="fa-solid fa-play"></i><span>${display}</span> `
            let adv = new google.maps.marker.AdvancedMarkerElement({
              map: this.map,
              position: { lat: lat, lng: lng },
              title: 'Trip Start',
              content: markerContent1 // This renders the HTML with icon + text
            })

            this.highlightedMarkers.push(adv)

            const i = points.length - 1

            // display = '⏹'
            display = ''

            lat = points[i].lat
            lng = points[i].lng
            // adv = this.advancedMarkerTag(lat, lng, display, 0)
            // -----------------------------------------------------------------------------------
            // -----------------------------------------------------------------------------------

            var content = document.createElement('div')
            content.className = 'trip-tag'
            content.innerHTML = `<i class="fa-solid fa-stop"></i><span>${display}</span>`
            adv = new google.maps.marker.AdvancedMarkerElement({
              map: this.map,
              position: { lat: lat, lng: lng },
              title: 'Trip Stop',
              content: content // This renders the HTML with icon + text
            })

            this.highlightedMarkers.push(adv)

            this.highlightedMarkers.forEach((marker, index) => {
              marker.setMap(this.map)
            })

            if (this.zoomButton) {
              this.map.fitBounds(stop.bounds)
            }
            //
            //
            //
          } else {
            //
            // This is a wait because it has no point, we therefore need
            // to make its lable yellow.
            //
            const point = stop.position

            this.highlightedMarkers = []
            // now draw the start and end markers
            // const display = stop.label
            //const display = '⏸'
            const display = ''
            const lat = point.lat
            const lng = point.lng
            // const adv = this.advancedMarkerTag(lat, lng, display, 0, 'wait-tag')

            // -----------------------------------------------------------------------------------
            // -----------------------------------------------------------------------------------

            var content3 = document.createElement('div')
            content3.className = 'wait-tag'
            content3.innerHTML = `<i class="fa-solid fa-pause"></i><span>${display}</span>`
            const adv = new google.maps.marker.AdvancedMarkerElement({
              map: this.map,
              position: { lat: lat, lng: lng },
              title: 'Trip Stop',
              content: content3 // This renders the HTML with icon + text
            })

            this.highlightedMarkers.push(adv)

            adv.setMap(this.map)

            if (this.zoomButton) {
              this.map.fitBounds(stop.bounds)
            }
          }
        }
      },

      /**
       *   V 0.1.0 - 2025-02-17
       *      -
       */
      calculateTripTime (trip1) {
        if (trip1.points.length === 0) {
          throw new Error('Both trips must have at least one point')
        }

        const beg = trip1.points[0].tm
        const end = trip1.points[trip1.points.length - 1].tm

        return end - beg
      },

      /**
       *   V 0.1.0 - 2025-02-10
       *      -
       */
      calculateTimeDifference (trip1, trip2) {
        if (trip1.points.length === 0 || trip2.points.length === 0) {
          throw new Error('Both trips must have at least one point')
        }

        const lastTmFirstTrip = trip1.points[trip1.points.length - 1].tm
        const firstTmSecondTrip = trip2.points[0].tm

        return firstTmSecondTrip - lastTmFirstTrip
      },

      /**
       * Formats an ISO date string to HH:mm format.
       * @param {string} isoDateString - The ISO date string to format.
       * @returns {string} - The formatted time in HH:mm.
       */
      formatTime (isoDateString) {
        const date = new Date(isoDateString)
        // Function to pad single digit numbers with a leading zero
        const pad = (n) => (n < 10 ? '0' + n : n)
        // Format the time as HH:mm
        const formattedTime = `${pad(date.getUTCHours())}:${pad(
          date.getUTCMinutes()
        )}`
        return formattedTime
      },

      msToHHMM (milliseconds) {
        const hours = Math.floor(milliseconds / 3600000)
        const minutes = Math.floor((milliseconds % 3600000) / 60000)

        const paddedHours = String(hours).padStart(2, '0')
        const paddedMinutes = String(minutes).padStart(2, '0')
        return `${paddedHours}:${paddedMinutes}`
      },

      /**
       * */
      getEventMarkerContent (eventId, element = false) {
        const eventInfo = {
          1: { text: 'Over Speeding', icon: 'fa-gauge-high', color: '#ff0000' },
          2: {
            text: 'Harsh Braking',
            icon: 'fas fa-step-forward', // "fa-triangle-exclamation",
            color: '#ff9800'
          },
          3: {
            text: 'Harsh Acceleration',
            icon: 'fas fa-angle-double-right',
            color: '#2196F3'
          },
          4: {
            text: 'Harsh Turn',
            icon: 'fas fa-undo-alt',
            color: '#4CAF50'
          },
          5: {
            text: 'Harsh Turn',
            icon: 'fas fa-redo',
            color: '#4CAF50'
          },
          6: {
            text: 'Harsh Bump',
            icon: 'fas fa-exclamation-triangle', // "fas fa-bolt",
            color: '#795548'
          },
          7: { text: 'Harsh Turn', icon: 'fa-rotate', color: '#607D8B' },
          9: {
            text: 'Accident',
            icon: 'fas fa-car-crash',
            color: '#f44336'
          },
          12: {
            text: 'Position Polling Message',
            icon: 'fa-map-marker-alt',
            color: '#9C27B0'
          },
          13: { text: 'RPM', icon: 'fa-rotate', color: '#3F51B5' },
          14: { text: 'Speed', icon: 'fa-tachometer-alt', color: '#03A9F4' },
          15: {
            text: 'OBD Disconnected Alarm',
            icon: 'fa-plug-circle-xmark',
            color: '#FF5722'
          },
          16: {
            text: 'DID Disconnected Alarm',
            icon: 'fa-unlink',
            color: '#9E9E9E'
          },

          17: {
            text: '',
            icon: 'fas fa-stop',
            color: '#222222'
          }

        }

        const event = eventInfo[eventId] || {
          text: 'Unknown Event',
          icon: 'fa-question',
          color: '#000'
        }
        if (element) {
          return event
        } else {
          return `<div class="marker-box" style="background-color: ${event.color};" title="${event.text}">
                      <i class="fa-solid ${event.icon}" style="font-size: 14px;" ></i>
                  </div>`
        }
      },

      /**
       *
       *   V 0.2.1 - 2025-03-18
       *       - Added Totals
       *       - Changed yellow box title
       *
       *   V 0.1.0 - 2025-02-19
       *      - Plot the total trip distance etc for
       */
      plotFullTripMarkers () {

        // debugger;

        let bottomDisplay = ''

        if (this.journeyPath.length > 0) {
          this.debug
            ? console.log(`plotFullTripMarkers: ${this.journeyPath.length}`)
            : null

          // ---------------------------------------------------------

          let currentTrip
          let nextTrip
          let totalDistance = 0 //
          let totalIdleTime = 0
          let totalTime = 0
          for (let i = 0; i < this.trips.length - 1; i++) {
            currentTrip = this.trips[i]
            nextTrip = this.trips[i + 1]

            totalDistance += currentTrip.distance

            totalIdleTime += this.calculateTimeDifference(currentTrip, nextTrip)

            const ms = this.calculateTripTime(currentTrip)

            totalTime += ms

            this.$debug
              ? console.log(
                `Dist: ${totalDistance} Idle: ${totalIdleTime}  ${totalIdleTime}`
              )
              : null
          }
          // ---------------------------------------------------------

          this.totalTripMarkers = []
          // now draw the start and end markers
          let display = `Day Start ⏵ ${this.formatTime(this.journeyPath[0].tm)}`
          let lat = this.journeyPath[0].lat
          let lng = this.journeyPath[0].lng
          // let adv = this.advancedMarkerCreate(lat, lng, display, 0)

          bottomDisplay = display

          var content = document.createElement('div')
          content.className = 'trip-tag'
          content.innerHTML = `<span>Day Start </span><i class="fa-solid fa-play"></i><span>${this.formatTime(this.journeyPath[0].tm)}</span>`
          var adv = new google.maps.marker.AdvancedMarkerElement({
            map: this.map,
            position: { lat: lat, lng: lng },
            title: 'Trip Start',
            content: content // This renders the HTML with icon + text
          })

          this.totalTripMarkers.push(adv)

          const i = this.journeyPath.length - 1

          display = `Day End ⏹ ${this.formatTime(this.journeyPath[i].tm)}`
          lat = this.journeyPath[i].lat
          lng = this.journeyPath[i].lng
          // adv = this.advancedMarkerCreate(lat, lng, display, 0)

          content = document.createElement('div')
          content.className = 'trip-tag'
          content.innerHTML = `<span>Day End </span><i class="fa-solid fa-play"></i><span>${this.formatTime(this.journeyPath[i].tm)}</span>`
          adv = new google.maps.marker.AdvancedMarkerElement({
            map: this.map,
            position: { lat: lat, lng: lng },
            title: 'Trip Start',
            content: content // This renders the HTML with icon + text
          })

          this.totalTripMarkers.push(adv)

          this.totalTripMarkers.forEach((marker, index) => {
            marker.setMap(this.map)
          })

          bottomDisplay =
            `${bottomDisplay} - ${display} <br> ` +
            `Total: Dist ${totalDistance.toFixed(0)} km ` +
            ` -- Dur ${this.msToHHMM(totalTime)} ` +
            `-- Idle ${this.msToHHMM(totalIdleTime)} hrs`

          this.updateSpeed(this.replaceMediaIcons(bottomDisplay))
        }
      },

      replaceMediaIcons (text) {
        return text
          .replace('⏸', '<i class="fa fa-pause"></i>')
          .replace('⏹', '<i class="fa fa-stop"></i>')
          .replace('⏵', '<i class="fa fa-play"></i>')
      },

      /**
       *  ---------------------------------------------------------------------------------------------------
       *   V 0-.2.0 - 2025-03-10
       *     - Added violations
       *
       *   V 0.1.0 - 2025-02-17
       *     - Make start & end displayt
       *
       *  ---------------------------------------------------------------------------------------------------
       */
      processTrip (currentTrip, index) {
        try {

          // ))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))

          const len = currentTrip.points.length
          const displayBeg = `⏵ ${this.formatTime(currentTrip.points[0].tm)}`
          const displayEnd = `⏹ ${this.formatTime(
            currentTrip.points[len - 1].tm
          )}`

          const lat = currentTrip.points[0].lat
          const lng = currentTrip.points[0].lng

          const display = `⏸ End @${displayBeg}`

          const adv = this.advancedMarkerCreate(lat, lng, this.replaceMediaIcons(display), index + 1)
          this.advancedMarkers.push(adv)

          if (currentTrip.violations) {
            // debugger;
            currentTrip.violations.forEach((violation) => {
              // debugger;

              const vio2 = this.advancedMarkerFontAwesome(
                violation.Lat,
                violation.Lng,
                violation.Desc,
                violation.Id
              )

              this.eventMarkers.push(vio2)
            })
          }

          const tripBounds = new google.maps.LatLngBounds()

          currentTrip.points.forEach((point) => {
            tripBounds.extend(point)
          })

          const ms = this.calculateTripTime(currentTrip)

          const tt = `${this.msToHHMM(ms)}`

          const label =
            `${displayBeg}—${displayEnd} <br>` +
            `Trip:${index + 1} -- ` +
            `Dur: ${tt} hrs -- ` +
            `Dist: ${currentTrip.distance.toFixed(1)} km`

          this.stops.push({
            label: this.replaceMediaIcons(label),
            position: currentTrip.points[0],
            bounds: tripBounds,
            trip: currentTrip.points,
            tripNum: index
          })
          console.log(label)

          return label
        } catch (e) {
          console.log('processTrip()')
          console.log(e)
        }
      },

      processWait (currentTrip, nextTrip) {
        try {
          this.$debug ? console.log('processWait()') : null
          const waitBounds = new google.maps.LatLngBounds()

          waitBounds.extend(currentTrip.points[0])
          waitBounds.extend(nextTrip.points[0])

          const ms = this.calculateTimeDifference(currentTrip, nextTrip)

          const waitLabel = `&nbsp;&nbsp;⏸ Wait: ${this.msToHHMM(
            ms
          )} hrs  &nbsp;&nbsp;  <br> &nbsp;&nbsp; &nbsp;&nbsp;`

          this.$debug ? console.log(`${waitLabel}`) : null

          this.stops.push({
            label: this.replaceMediaIcons(waitLabel),
            position: nextTrip.points[0],
            bounds: waitBounds,
            trip: null
          })
        } catch (e) {
          console.log('processWait()')
          console.log(e)
        }
      },

      /**
       *  V 0.4.0 - 2025-12-03
       *     - When there was only 2 trips this routine was failing
       *       so added fiex.
       *
       *  V 0.3.0 - 2025-05-12
       *     - first trip was not being plotted
       *
       *  V 0.2.0 - 2025-03-11
       *    -  Fixed issue with the last trip in day
       *
       *  V 0.1.0 - 2025-02-17
       *    -
       *
       */
      processData () {
        this.journeyPath = []
        this.tripPath = []
        this.stops = []

        this.trips = this.tripData.map(
          (t) => new Trip(t.Points, t.Distance, t.label, t.Violations)
        )

        this.$debug ? console.log(`processData()  ${this.trips.length}`) : null

        const first = true

        let currentTrip
        let nextTrip
        let firstTrip

        this.advancedMarkers = []

        //
        // Iterate through the array
        //
        let lbl = ''
        let totalDistance = 0 // <

        if (this.trips.length === 1) {
          currentTrip = this.trips[1]

          this.journeyPath = this.journeyPath.concat(currentTrip.points)

          lbl = this.processTrip(currentTrip, i)

          totalDistance += currentTrip.Distance

          this.trips[1].label = lbl

          // this.processWait(currentTrip, nextTrip)

        }
        else {

          for (let i = 0; i < this.trips.length - 1; i++) {
            currentTrip = this.trips[i]
            nextTrip = this.trips[i + 1]

            if (i === 0) {
              this.journeyPath = this.journeyPath.concat(currentTrip.points)
            }

            this.journeyPath = this.journeyPath.concat(nextTrip.points)

            lbl = this.processTrip(currentTrip, i)

            totalDistance += currentTrip.Distance // <

            this.trips[i].label = lbl

            this.processWait(currentTrip, nextTrip)
          }

          lbl = this.processTrip(nextTrip, this.trips.length)
        }

        this.cycleThroughAll(true)

      },

      /**
       *  V 0.1.0 - 2024-07-09
       *
       * */

      cycleThroughAll (visible) {
        //
        this.advancedMarkers.forEach((marker, index) => {
          if (visible) {
            marker.setMap(this.map)
          } else {
            marker.setMap(null)
          }
        })
      },

      ///
      ///
      ///  V 0.1.0 - 2025-02-03
      ///
      ///
      zoomToTrip (index) {
        try {
          if (index > this.tripPath.length) {
            console.log('Trip Index bound exceeded')
          }

          const bounds = new google.maps.LatLngBounds()

          this.trips[index].points.forEach((point) => {
            bounds.extend(point)
          })

          //  Fit these bounds to the map
          this.map.fitBounds(bounds)
        } catch (e) {
          console.log(e)
        }
      },

      ///
      ///  V 0.1.0 - 2025-02-03
      ///
      zoomToJourney () {
        try {
          const bounds = new google.maps.LatLngBounds()

          // Expand bounds to fit all points
          this.journeyPath.forEach((point) => {
            bounds.extend(point)
          })

          //  Fit these bounds to the map
          this.map.fitBounds(bounds)
        } catch (e) {
          console.log(e)
        }
      },

      // plot markers and create an array
      plotMarkerArray (i, posLatLng, iconImage, titleText, markerType) {
        // Shapes define the clickable region of the icon.
        // The type defines an HTML &lt;area&gt; element 'poly' which
        // traces out a polygon as a series of X,Y points. The final
        // coordinate closes the poly by connecting to the first
        // coordinate.
        const shape = {
          coord: [1, 1, 48, 48],
          type: 'circle'
        }

        let zIndex = 50

        if (markerType > 5) {
          zIndex = 150
        }

        this.markers[i] = new google.maps.Marker({
          position: posLatLng,
          map: this.map,
          // shadow: shadow,
          icon: iconImage,
          shape,
          title: titleText,
          zIndex
        })
      },

      initMap () {
        // this.fetchData();

        if (!this.journeyPath.length) return

        const mapOptions = {
          zoom: 7,
          // center: new this.google.maps.LatLng(-28.87916, 24.3291),
          center: this.journeyPath[0], // Center on the first point
          mapTypeId: 'roadmap',
          mapId: 'b00531e667bdc68a',
          mapTypeControl: false, // Disables the Satellite button
          streetViewControl: false // This disables the Pegman control
        }

        this.map = new google.maps.Map(
          document.getElementById('map'),

          mapOptions
        )

        // Plot the journey polyline
        this.tripPolyline = new google.maps.Polyline({
          path: this.journeyPath,
          geodesic: true,
          strokeColor: '#FF0000',
          strokeOpacity: 0.8,
          strokeWeight: 4
        })

        this.tripPolyline.setMap(this.map)

        // Add text to the map
        // -------------------------------------------------------------
        var centerControlDiv = document.createElement('div')
        var centerControl = new SpeedGmapControl(centerControlDiv, this.map)
        centerControlDiv.index = 1

        this.output = centerControl.GmapControlOutput

        // TOP_CENTER indicates that the control should be placed along the top center of the map.
        // TOP_LEFT indicates that the control should be placed along the top left of the map, with any sub-elements of the control "flowing" towards the top center.
        // TOP_RIGHT indicates that the control should be placed along the top right of the map, with any sub-elements of the control "flowing" towards the top center.
        // LEFT_TOP indicates that the control should be placed along the top left of the map, but below any TOP_LEFT elements.
        // RIGHT_TOP indicates that the control should be placed along the top right of the map, but below any TOP_RIGHT elements.
        // LEFT_CENTER indicates that the control should be placed along the left side of the map, centered between the TOP_LEFT and BOTTOM_LEFT positions.
        // RIGHT_CENTER indicates that the control should be placed along the right side of the map, centered between the TOP_RIGHT and BOTTOM_RIGHT positions.
        // LEFT_BOTTOM indicates that the control should be placed along the bottom left of the map, but above any BOTTOM_LEFT elements.
        // RIGHT_BOTTOM indicates that the control should be placed along the bottom right of the map, but above any BOTTOM_RIGHT elements.
        // BOTTOM_CENTER indicates that the control should be placed along the bottom center of the map.
        // BOTTOM_LEFT indicates that the control should be placed along the bottom left of the map, with any sub-elements of the control "flowing" towards the bottom center.
        // BOTTOM_RIGHT indicates that the control should be placed along the bottom right of the map, with any sub-elements of the control "flowing" towards the bottom center.

        this.map.controls[google.maps.ControlPosition.BOTTOM_CENTER].push(
          centerControlDiv
        )

        this.plotFullTripMarkers()

        if (this.eventsButton) {
          this.eventMarkers.forEach((marker, index) => {
            marker.setMap(this.map)
          })
        }

        //
        // // Array of all possible events with different locations
        // const events = [
        //   { lat: -26.4749, lng: 27.4194, id: 1 }, // Over Speeding
        //   { lat: -26.4849, lng: 27.5094, id: 2 }, // Harsh Braking
        //   { lat: -26.4649, lng: 27.6294, id: 3 }, // Harsh Acceleration
        //   { lat: -26.4549, lng: 27.7394, id: 4 }, // Harsh Left Turn
        //   { lat: -26.4449, lng: 27.8494, id: 5 }, // Harsh Right Turn
        //   { lat: -26.4349, lng: 27.9594, id: 6 }, // Harsh Bump
        //   { lat: -26.4249, lng: 27.1694, id: 7 }, // Harsh Turn
        //   { lat: -26.4149, lng: 27.2794, id: 9 }, // Accident
        //   { lat: -26.4049, lng: 27.3894, id: 12 }, // Position Polling Message
        //   { lat: -26.3949, lng: 27.4994, id: 13 }, // RPM
        //   { lat: -26.3849, lng: 27.5394, id: 14 }, // Speed
        //   { lat: -26.3749, lng: 27.6194, id: 15 }, // OBD Disconnected Alarm
        //   { lat: -26.3649, lng: 27.7294, id: 16 } // DID Disconnected Alarm
        // ]

        this.zoomToJourney()

        if (!this.allTripsButton) {
          this.tripPolyline.setMap(null)
        }

      }
    }
  }
</script>

<style>
  .refresh-button {
    z-index: 1 !important;
    top: 20px !important;
    left: 10px;
    /* width: 100px; */
    height: 30px !important;
    position: absolute;
    background-color: #ffffff;
    border-radius: 4px;
    border: 1px solid #202730;
    padding: 3px;
    color: #fff;
    height: 42px;
  }
  /*

  /**

      #map_old {
        position: absolute;
        top: 0;
        left: 0;
        width: 103vw;
        height: 95vh;
      }

      #map {
        position: absolute;
        left: 0px;
        width: calc(100%);
        height: calc(100%);
      }
  */

  /* Center the progress circular over the map */
  .progress-overlay {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 10; /* Ensure it’s above the map */
  }

  .v-messages {
    min-height: 0px !important;
  }

  /*

  */
  .toggle-button-zoom {
    /**
     *   2024-07-22 :
     *      - Added for toggle button
     */
    z-index: 1 !important;
    top: 5px;
    left: 60px;
    /* width: 100px; */
    height: 30px !important;
    position: absolute;
    background-color: #ffffff;
    border-radius: 4px;
    border: 1px solid #202730;
    padding: 3px;
    color: #fff;
    height: 42px;
  }

  /* HTML marker styles */
  /* HTML marker styles */
  .trip-tag-highlight {
    background-color: #fff2a0;
    border-radius: 8px;
    color: #000000;
    font-size: 14px;
    padding: 10px 15px;
    position: relative;
    z-index: 100;
  }

  /* HTML marker styles

    background-color: #fff400e8;
    border-radius: 8px;
    color: #080808;
    font-size: 14px;
    padding: 10px 15px;
    position: relative;
    z-index: 50;

  */
  .trip-tag {
    z-index: 1 !important;
    background-color: #fff400e8;
    border-radius: 8px;
    color: #080808;
    font-size: 14px;
    padding: 1px 6px;
    position: relative;
    z-index: 50;
    border: 2px solid black; /* Black border */
  }

    .trip-tag::after {
      content: "";
      position: absolute;
      left: 50%;
      top: 100%;
      transform: translate(-50%, 0);
      width: 0;
      height: 0;
      border-left: 8px solid transparent;
      border-right: 8px solid transparent;
      /* border-top: 8px solid #ffff00; */
      border-top: 8px solid #424242;
    }

  /*
      V 0.1.0 - 2025-09-30
        -   Changed wait tag marker to dark green and made it bigger
  */
  .wait-tag {
    background-color: darkgreen; /**#6ef442; */
    border-radius: 8px;
    color: white; /**#252526; */
    font-size: 24px;
    padding: 1px 6px;
    position: relative;
    z-index: 50;
    border-width: thick;
    border-color: black;
    border: 2px solid; /* Black border */
  }

    .wait-tag::after {
      content: "";
      position: absolute;
      left: 50%;
      top: 100%;
      transform: translate(-50%, 0);
      width: 0;
      height: 0;
      border-left: 8px solid transparent;
      border-right: 8px solid transparent;
      border-top: 8px solid darkgreen;
    }

  .journey-navigation {
    position: absolute;
    left: 5px;
    top: 5px;
    background: rgba(255, 255, 255, 0.9);
    padding: 2px;
    /* border-radius: 5px; */
    max-height: 90%;
    /* overflow-y: auto; */
    display: flex;
    flex-direction: column;
    /* gap: 5px; */
    padding-bottom: 20px;
  }

  .journey-stops {
    position: absolute;
    left: 10px;
    top: 10px;
    background: rgba(255, 255, 255, 0.9);
    padding: 4px;
    border-radius: 5px;
    max-height: 90%;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 5px;
  }

  .marker-box {
    position: relative;
    width: 25px;
    height: 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: white;
    font-weight: bold;
    border-radius: 8px;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.3);
    cursor: pointer;
  }

    .marker-box::before {
      content: "";
      position: absolute;
      width: 60px; /* Expands the hover area */
      height: 60px;
      top: -5px;
      left: -5px;
      background: transparent;
    }
</style>
